require('./footerAdvice.scss');

// @vendors
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

// @components
import { OKButton } from 'commonsComponents/OKButton'

class FooterAdvice extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isOpenAdvice: true,
        }
    }

    closeAdvice = () => {
        this.setState({ isOpenAdvice: false })
    }

    handleCloseAdvice = () => {
        const { onCloseCallback } = this.props;
        onCloseCallback()
        this.closeAdvice()
    }

    handleButtonClick = () => {
        const { onClickButton } = this.props;
        onClickButton()
        this.closeAdvice()
    }

    render() {
        const { isOpenAdvice } = this.state;
        const { title, description, textButton } = this.props;
        const sectionClasses = classNames('footer-advice', { 'footer-advice--show': isOpenAdvice })

        return (
            <section className={sectionClasses}>
                <div className="footer-advice__close-button-container">
                    <div className="footer-advice__close-button-container__button" onClick={this.handleCloseAdvice}>
                        <span className="footer-advice__close-button-container__button__icon icon icon-cerrar" />
                    </div>
                </div>
                <h4 className="footer-advice__title">
                    {title}
                </h4>
                <p className="footer-advice__sub-title">
                    {description}
                </p>
                <div className="footer-advice__button-container">
                    <OKButton
                        size="block"
                        onClick={this.handleButtonClick}
                    >
                        {textButton}
                    </OKButton>
                </div>
            </section>
        )
    }
}

FooterAdvice.defaultProps = {
    onClickButton: () => { },
    onCloseCallback: () => { },
}

FooterAdvice.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    textButton: PropTypes.string.isRequired,
    onClickButton: PropTypes.func,
    onCloseCallback: PropTypes.func,
}

export default FooterAdvice;
